import type { Suit as SuitType } from '@durakapp/engine';
import { suitColor } from './suitColor.js';

interface Props {
  suit: SuitType;
  size?: number;
  filled?: boolean;
}

export function Suit({ suit, size = 20, filled = true }: Props) {
  const color = suitColor(suit);
  const stroke = filled ? color : 'currentColor';
  const fill = filled ? color : 'none';
  const common = { width: size, height: size, viewBox: '0 0 24 24', fill, stroke } as const;
  switch (suit) {
    case 'spades':
      return (
        <svg {...common} aria-label="spades">
          <path d="M12 2c4 4 8 7 8 11a5 5 0 0 1-7 4.6l1 4.4h-4l1-4.4A5 5 0 0 1 4 13c0-4 4-7 8-11z" />
        </svg>
      );
    case 'hearts':
      return (
        <svg {...common} aria-label="hearts">
          <path d="M12 21s-7-4.6-9.3-9A5.5 5.5 0 0 1 12 6a5.5 5.5 0 0 1 9.3 6c-2.3 4.4-9.3 9-9.3 9z" />
        </svg>
      );
    case 'diamonds':
      return (
        <svg {...common} aria-label="diamonds">
          <path d="M12 2l8 10-8 10-8-10z" />
        </svg>
      );
    case 'clubs':
      return (
        <svg {...common} aria-label="clubs">
          <path d="M12 2a4 4 0 0 1 4 4 4 4 0 0 1-.6 2.1A4 4 0 1 1 12 13a4 4 0 1 1-3.4-4.9A4 4 0 0 1 12 2zm-1 13l1 4.4h0L13 15h-2z" />
        </svg>
      );
  }
}
